import React, { useState, useEffect, useCallback } from 'react';
import './career.css';
import Footer from '../Component/NewFooter';
import SplashScreen from '../Component/SplashScreen';
import axios from 'axios';

const BASE_URL      = "https://api.jeyshawnng.com";
const FETCH_TIMEOUT = 8000;
const CACHE_KEY      = "jeyshawn_csr_data";

/* ── Helpers ───────────────────────────────────────────────────── */
function parseCsrData(db) {
  return {
    bannerImage:    db?.bannerImage    || "",
    secondaryImage: db?.secondaryImage || "",
    title:          db?.title          || "",
    commitment: {
      heading:        db?.commitmentLabel                      || "",
      intro:          Array.isArray(db?.paragraphs)            ? db.paragraphs            : [],
      supportHeading: db?.sections?.[0]?.heading                || "",
      supportItems:   Array.isArray(db?.sections?.[0]?.items)  ? db.sections[0].items     : [],
      goal:           db?.closingText                           || "",
    },
  };
}

function readCache() {
  try { return JSON.parse(localStorage.getItem(CACHE_KEY)); } catch { return null; }
}
function writeCache(data) {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch {}
}

/* ── Sub-components ────────────────────────────────────────────── */
function ErrorScreen({ onRetry }) {
  return (
    <div style={{
      position: "fixed", inset: 0, background: "#09090b", zIndex: 9999,
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px",
    }}>
      <div style={{ textAlign: "center" }}>
        <p style={{ color: "rgba(255,255,255,0.85)", fontSize: "1.1rem", fontFamily: "Georgia, serif", letterSpacing: "0.04em", marginBottom: "8px" }}>
          Poor internet connection.
        </p>
        <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.8rem", letterSpacing: "0.08em", textTransform: "uppercase" }}>
          Please check your connection and try again.
        </p>
      </div>
      <button
        onClick={onRetry}
        style={{
          marginTop: "8px", padding: "10px 32px", background: "transparent",
          border: "1px solid rgba(255,255,255,0.25)", color: "rgba(255,255,255,0.7)",
          fontSize: "0.8rem", letterSpacing: "0.12em", textTransform: "uppercase",
          cursor: "pointer", fontFamily: "Georgia, serif", transition: "border-color 0.2s, color 0.2s",
        }}
        onMouseEnter={e => { e.target.style.borderColor = "#d4af72"; e.target.style.color = "#d4af72"; }}
        onMouseLeave={e => { e.target.style.borderColor = "rgba(255,255,255,0.25)"; e.target.style.color = "rgba(255,255,255,0.7)"; }}
      >
        Try Again
      </button>
    </div>
  );
}

/* ── Page ──────────────────────────────────────────────────────── */
const CSR = () => {
  const cached = readCache();

  const [status, setStatus]   = useState(cached ? "ready" : "splash-loading");
  const [csrData, setCsrData] = useState(cached || null);

  const doFetch = useCallback(async (background = false) => {
    const controller = new AbortController();
    const timeoutId  = setTimeout(() => controller.abort(), FETCH_TIMEOUT);

    try {
      const { data } = await axios.get(`${BASE_URL}/api/csr`, { signal: controller.signal });
      clearTimeout(timeoutId);

      const parsed = parseCsrData(data?.data);
      writeCache(parsed);
      setCsrData(parsed);

      if (!background) setStatus("splash-done");
    } catch (err) {
      clearTimeout(timeoutId);
      if (background) {
        console.warn("Background refresh failed for /api/csr:", err.message);
      } else {
        setStatus("error");
      }
    }
  }, []);

  useEffect(() => {
    doFetch(!!cached);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === "error") {
    return <ErrorScreen onRetry={() => { setStatus("splash-loading"); doFetch(false); }} />;
  }
  if (status === "splash-loading") return <SplashScreen blocking />;

  const data = csrData;

  return (
    <>
      {status === "splash-done" && (
        <SplashScreen autoExit onDone={() => setStatus("ready")} />
      )}

      <div className="img_carrierse">
        {data.bannerImage && <img src={data.bannerImage} alt="img" />}
      </div>

      <div className="careers-container">
        <div className="careers-content">
          <div className="title-section">
            <h1 className="careers-title">{data.title}</h1>
            <div className="orange-underline"></div>
          </div>

          <div className="csr_content">
            <div className="csr_section">
              <p className="intro-text mkbold">{data.commitment.heading}</p>

              {data.commitment.intro.map((text, i) => (
                <p className="intro-tex" key={i}>{text}</p>
              ))}

              <p className="intro-text">{data.commitment.supportHeading}</p>

              <ul className="catext">
                {data.commitment.supportItems.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>

              <p className="intro-text">{data.commitment.goal}</p>
            </div>

            <div className="img_cover">
              <div className="img_carr">
                {data.secondaryImage && <img src={data.secondaryImage} alt="img" />}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CSR;